<template>
    <div class="app-container">
    <!-- 左侧固定侧边导航 -->
    <aside class="sidebar">
      <div class="nav-scroll">
        <div :class="menu.isSelect ? 'nav-item active' : 'nav-item'" v-for="(menu, index ) in menuList" :id="index" @click="menuClick(menu)">
          <div v-if="menu.isSelect">
            <img :src="menu.selectimg" style="width: 23px; height: 23px" /> 
          </div>
          <div v-else>
            <img :src="menu.blackImg" style="width: 23px; height: 23px" /> 
          </div>
          <span>{{ menu.title}}</span>
        </div> 
      </div>
      <!-- 登录/未登录状态切换，可通过修改isLogin的值控制 -->
      <div class="user-avatar" v-if="isLogin"> 
        <div @click="userloginOut">
          <i class="unlogin-icon">👤</i>
          <span>{{ username }}</span>
        </div> 
      </div>
      <div class="user-avatar unlogin" v-else>
        <div @click="userLogin">
          <i class="unlogin-icon">👤</i>
          <span>未登录</span>
        </div>
      </div>
    </aside>

    <!-- 主内容区域 -->
    <main class="main-content">
       <router-view></router-view>
    </main>
    <GlobalLoginDialog v-model="boxShowDialog" @handleSuccess="userForceUpdate"></GlobalLoginDialog>
  </div> 
</template>
<script>
import { menu } from '@/utils/menu.js';
import { loginManager } from '@/utils/loginManager.js'
import GlobalLoginDialog from '@/components/dialog/GlobalLoginDialog.vue'
import { ElMessageBox } from 'element-plus'

export default {
    name: 'layout',
    components: {
      GlobalLoginDialog
    },
    data() {
      return {
        boxShowDialog: false,
        isLogin : false,
        menuList : null,
        username : localStorage.getItem('loginUser'),
      }
    },
    mounted() {
      this.openGetMenu()
    },
    methods: {
        openGetMenu() {
          this.menuList = menu;
          const path = window.location.pathname
          this.menuList.forEach(el => {
            el.isSelect = false;
            if(el.router === path) {
              el.isSelect = true;
            }
            return el; 
          });

          if(localStorage.getItem('loginUser')) {
            this.isLogin = true;
          }
        },
        menuClick(menu) {
          let jumpPage = "/web/writing";
          let isLogin = false;
          this.menuList.forEach(el => {
            el.isSelect = false;
            if(el.routerId === menu.routerId) {
              el.isSelect = true;
              jumpPage = menu.router;
              isLogin = menu.isLogin;
            }
            return el;
          });
          this.$router.push(jumpPage); 
        }, 
        async userLogin() {
          await loginManager.show()
        },
        userForceUpdate(){
          this.isLogin = true
          this.username = localStorage.getItem('loginUser')
        },
        userloginOut(){
          ElMessageBox.confirm(
            '是否退出当前账号?',
            '退出登录',
            {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning',
            }
          )
            .then(() => {
              localStorage.removeItem('loginUser')
              localStorage.removeItem('loginUserToken')
              this.isLogin = false
              this.username = '' 
              this.$router.push('/web/writing')
              let _that = this
              setTimeout(() => {
                _that.openGetMenu()
              }, 100)
            })
            .catch(() => { 
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 左侧固定侧边栏 - 极简无动效版 */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 72px;
  background: #ffffff; /* 纯白背景，无渐变 */
  border-right: 1px solid #eaeef2; /* 更实的边框 */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 16px 0;
  z-index: 100;
}

/* 可滚动导航区域 */
.nav-scroll {
  flex: 1;
  overflow-y: auto;
  width: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 滚动条美化 - 保持功能但更低调 */
.nav-scroll::-webkit-scrollbar {
  width: 4px;
}

.nav-scroll::-webkit-scrollbar-track {
  background: #f5f7fa;
}

.nav-scroll::-webkit-scrollbar-thumb {
  background: #d0d7de;
}

.nav-scroll::-webkit-scrollbar-thumb:hover {
  background: #b0b8c1;
}

/* 菜单项 - 完全无动效 */
.nav-item {
  width: 52px;
  padding: 12px 0 8px 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  gap: 6px;
  text-align: center;
  background-color: transparent;
  border: none;
  position: relative;
  /* 完全移除所有过渡动画 */
  transition: none;
}

.nav-item i {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 22px;
  margin-bottom: 2px;
}

.nav-item span {
  display: block;
  width: 100%;
  text-align: center;
  line-height: 1.2;
}

/* 完全移除悬停效果 - 鼠标移上无任何变化 */
.nav-item:hover {
  background-color: transparent;
  color: #64748b;
  transform: none;
}

/* 激活状态 - 极简风格 */
.nav-item.active {
  background-color: #f0f7ff; /* 纯色背景，无渐变 */
  color: #0066cc;
  border-left: 3px solid #0066cc;
}

.nav-item.active span {
  font-weight: 600;
  color: #0066cc;
}

.nav-item.active img {
  /* 激活状态的图片如果有特殊样式可以保留，但无过渡 */
}

/* 用户头像区域 - 无动效 */
.user-avatar {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0 8px 0;
  border-top: 1px solid #eaeef2;
  width: 100%;
  text-align: center;
  cursor: pointer;
  transition: none;
}

/* 完全移除头像悬停效果 */
.user-avatar:hover {
  background-color: transparent;
}

.user-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-bottom: 6px;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.user-avatar span {
  font-size: 11px;
  font-weight: 500;
  color: #475569;
  text-align: center;
  max-width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 2px;
}

/* 未登录样式 - 无动效 */
.user-avatar.unlogin {
  color: #94a3b8;
}

.user-avatar.unlogin:hover {
  background-color: transparent;
}

.user-avatar.unlogin .unlogin-icon {
  font-size: 36px;
  margin-bottom: 6px;
  display: block;
  opacity: 0.7;
  transition: none;
}

.user-avatar.unlogin:hover .unlogin-icon {
  opacity: 0.7; /* 保持原样，无变化 */
  filter: none;
}

.user-avatar.unlogin span {
  color: #94a3b8;
}

/* 主内容区域 */
.main-content {
  position: fixed;
  background-color: #ffffff;
  left: 72px;
  right: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
}

.grid-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(#e0e0e0 1px, transparent 1px),
    linear-gradient(90deg, #e0e0e0 1px, transparent 1px);
  background-size: 20px 20px;
  opacity: 0.2;
  pointer-events: none;
}

.typing-indicator {
  position: absolute;
  right: 20px;
  display: flex;
  gap: 4px;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.typing-indicator:nth-child(2) {
  top: 100px;
}

.typing-indicator:nth-child(3) {
  bottom: 80px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #90caf9;
  animation: typing 1.4s infinite both;
}

.dot-1 {
  animation-delay: 0s;
}

.dot-2 {
  animation-delay: 0.2s;
}

.dot-3 {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  30% {
    transform: scale(1);
    opacity: 1;
  }
}

.input-area {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 8px 12px;
}

.input-area input {
  border: none;
  outline: none;
  padding: 8px 12px;
  font-size: 14px;
  width: 200px;
  background-color: transparent;
}

.voice-btn, .send-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background-color: #f5f5f5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: 0 4px;
}

.voice-btn:hover, .send-btn:hover {
  background-color: #e0e0e0;
}
</style>